import { Icon } from '@sravni/react-design-system';
import type { ButtonProps } from '@sravni/react-design-system/lib/Button';
import { Lock } from '@sravni/react-icons';

import { OfferButton } from '../OfferButton/OfferButton';

type LockedProps = {
  buttonProps?: ButtonProps;
};

export const Locked: FC<LockedProps> = ({ buttonProps }) => (
  <OfferButton
    {...buttonProps}
    variant="primary"
    color="dark"
    disabled
  >
    <Icon
      icon={<Lock />}
      size={16}
    />
  </OfferButton>
);
